<mat-slide-toggle [formControl]="formControlRef" [color]="color">
  <ng-content></ng-content>
</mat-slide-toggle>
